<template>
    <div class="private-trust-us">
        <div class="private-trust-us__text">
            <div
                v-for="(item, i) in items"
                :key="i"
                class="private-trust-us__text-item _whitespace-pre-wrap _mb-0-16"
                :class="{
                    'text-align-right': itemMeta[i][2] === 'right',
                }"
                :style="{
                    '--private-trust-us__text-item-left': itemMeta[i][2] === 'right' ? 'unset' : Number.parseInt(itemMeta[i][0]),
                    '--private-trust-us__text-item-right': itemMeta[i][2] === 'right' ? Number.parseInt(itemMeta[i][0]) : 'unset',
                    '--private-trust-us__text-item-top': Number.parseInt(itemMeta[i][1]),
                }"
            >
                <div
                    class="private-trust-us__text-item-image _mb-0-16 _desktop-hidden"
                    :class="{
                        [`private-trust-us__text-item-image_${i}`]: true,
                    }"
                ></div>
                <div class="_mb-8 private-trust-us__text-item-title">{{ item.title }}</div>
                <div class="p1 gray-text-light">{{ item.description }}</div>
            </div>
        </div>
        <div class="private-trust-us__bg"></div>
    </div>
</template>
<script>
export default {
    name: 'PrivateTrustUs',
    data() {
        return {
            items: [
                {
                    title: 'Лучший инвестиционный\n советник в сфере недвижимости\n 2023',
                    description: 'по версии журнала «Wealth Navigator»',
                },
                {
                    title: 'ТОП-3 среди лучших\n руководителей Private Banking',
                    description: 'по версии медиапроекта «Банковское\n обозрение»',
                },
                {
                    title: 'Национальная банковская премия',
                    description: 'Победитель в номинации\n «Банковский продукт», «Спецпроект»',
                },
            ],
            itemMeta: [
                ['805px', '161px'],
                ['1480px', '226px'],
                ['1353px', '358px', 'right'],
            ]
        };
    },
};
</script>
<style lang="scss">
@import '../../assets/scss/base/variables';
@import '../../assets/scss/base/mixins';
@import '../../assets/scss/base/functions';

.private-trust-us {
    position: relative;

    @include fluid-1920('height', 694px, 646px);
    @include fluid('padding-bottom', 0px, 164px);

    @include mobile {
        height: auto;
    }

    &__bg {
        position: absolute;

        top: 0;
        left: 0;

        width: 100%;
        height: 100%;

        background-size: 100% auto;
        background-repeat: no-repeat;
        background-position: center bottom;

        &::after, &::before {
            content: "";
            position: absolute;
            top: 0px;
            left: 0px;
            right: 0px;
            bottom: 0px;
            display: block;
            background: inherit;
        }

        &::after {
            background-image: url('/local/templates/redesign/src/assets/img/private/private-trust-us/bg.webp');
            @include retina {
                background-image: url('/local/templates/redesign/src/assets/img/private/private-trust-us/bg@2.webp');
            }

            @include mobile {
                background-image: url('/local/templates/redesign/src/assets/img/private/private-trust-us/bg_mob.webp');

                @include retina {
                    background-image: url('/local/templates/redesign/src/assets/img/private/private-trust-us/bg_mob@2.webp');
                }
            }
        }

        &::before {
            background-image: url('/local/templates/redesign/src/assets/img/private/private-trust-us/bg-l.webp');
            @include retina {
                background-image: url('/local/templates/redesign/src/assets/img/private/private-trust-us/bg-l@2.webp');
            }

            @include mobile {
                background-image: url('/local/templates/redesign/src/assets/img/private/private-trust-us/bg_mob-l.webp');

                @include retina {
                    background-image: url('/local/templates/redesign/src/assets/img/private/private-trust-us/bg_mob-l@2.webp');
                }
            }

            animation: 3s linear infinite blink;

            @keyframes blink {
                0% {
                    opacity: 1;
                }
                20% {
                    opacity: .8;
                }
                40% {
                    opacity: .8;
                }
                60% {
                    opacity: .9;
                }
                80% {
                    opacity: .8;
                }

                100% {
                    opacity: 1;
                }
            }
        }
    }

    &__text {
        position: relative;
        z-index: 1;
    }

    &__text-item {
        position: absolute;
        @include mobile {
            position: relative;
        }

        @include mobile {
            text-align: center;
        }

        @include fluid('width', 350px);
        @include mobile {
            width: 100%;
        }

        left: calc(var(--private-trust-us__text-item-left) / 19.20 * 1vw);
        right: calc(var(--private-trust-us__text-item-right) / 19.20 * 1vw);
        top: calc(var(--private-trust-us__text-item-top) / 19.20 * 1vw);
        @include mobile {
            top: 0;
            left: 0;
        }
    }
    &__text-item-title {
        @include fluid('font-size', 20px, 18px);
        @include fluid('line-height', 28px, 24px);
        font-weight: 500;
    }

    &__text-item-image {
        @include fluid('height', 72px);
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;

        &_0 {
            background-image: url('/local/templates/redesign/src/assets/img/private/private-trust-us/planet1.webp');
        }
        &_1 {
            background-image: url('/local/templates/redesign/src/assets/img/private/private-trust-us/planet2.webp');
        }
        &_2 {
            background-image: url('/local/templates/redesign/src/assets/img/private/private-trust-us/planet3.webp');
        }

        @include retina {
            &_0 {
            background-image: url('/local/templates/redesign/src/assets/img/private/private-trust-us/planet1@2.webp');
            }
            &_1 {
                background-image: url('/local/templates/redesign/src/assets/img/private/private-trust-us/planet2@2.webp');
            }
            &_2 {
                background-image: url('/local/templates/redesign/src/assets/img/private/private-trust-us/planet3@2.webp');
            }
        }
    }
}
</style>
